(function() {
    var currentProductId = document.body.getAttribute('data-product-id');
    var products = getCookie("_sales_view_products");
    if(products == "") {
        products = [];
        products.push(currentProductId);
        setWaveCookie("_sales_view_products", JSON.stringify(products),1/3);
    } else {
        products = JSON.parse(getCookie("_sales_view_products"));
        switch (products.length) {
            case 1:
                if(products.indexOf(currentProductId) === -1) {
                    products.push(currentProductId);
                }
                break;
            case 2:
                if(products.indexOf(currentProductId) === -1) {
                    products.shift();
                    products.push(currentProductId);
                }
                break;
            default:
        }
        setWaveCookie("_sales_view_products", JSON.stringify(products),1/3);
    }
}());
